import React, { Component } from 'react';
import glamorous from 'glamorous';
import Container from '../../blocks/Container';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Panel from '../../common/Panel';
import Checkbox from '../../common/Checkbox';
import TextInput from '../../common/TextInput';
import Button from '../../blocks/Button';
import GdprDeletionModal from './GdprDeletionModal';
import InputGroup from '../../blocks/InputGroup';
import { spacing } from '../../../style';

const rowMargin = {
  ...spacing.MARGIN_BOTTOM_XL,
  ...spacing.MARGIN_TOP_XL
}

const WarningText = glamorous.p({
});

const NoteText = glamorous.p({
  fontStyle: 'italic',
  marginLeft: 20,
  ...rowMargin
})

const Password = glamorous.div({
  maxWidth: 450
})

const Row = glamorous.div({
  ...rowMargin
})

class LandingPage extends Component {
  state = {
    confirm_request: false,
    deleteChecked: false,
    requestPass: '',
    deletePass: '',
    modalOpen: false
  }

  onPasswordChange = (e) => {
    this.setState({[e.target.id]: e.target.value});
  }

  onCheckboxChange = (e) => {
    this.setState({[e.target.id]: !this.state[e.target.id]})
  }

  handleGdprInformation = (e) => {
    e.preventDefault();
    const formData = {
      'password': this.state.requestPass,
      'confirm_request': this.state.confirm_request
    };

    this.props.requestGdprInformation(formData);
  }

  toggleModal = () => {
    this.setState({'modalOpen': !this.state.modalOpen});
  }

  render() {
    const {
      confirm_request,
      requestPass,
      deleteChecked,
      deletePass,
      modalOpen
    } = this.state;
    
    const {
      profile,
      requestGdprDeletion,
      requestGdprInformation,
      hasError
    } = this.props;

    return (
      <Container>
        <Header>
          <Headline> GDPR </Headline>
        </Header>
        <Panel>
          <Header hasDescription>
            <Headline hasDescription>Request for Information</Headline>
          </Header>
          <Container>
            <WarningText>
              If you would like to request your data from MissTravel, 
              please certify that you are an EU resident and then use the "Request Information" option below.
            </WarningText>
              <form onSubmit={this.handleGdprInformation}>
                <Row>
                  <Checkbox
                    value={confirm_request}
                    id="confirm_request"
                    label="I certify, under penalty of fraud, that I am a resident of an EU country."
                    onChange={this.onCheckboxChange}
                  />
                </Row>
                <Row>
                  <Password>
                    <InputGroup vertical inputLabel="Password">
                      <TextInput id='requestPass' type="password" value={requestPass} onChange={this.onPasswordChange}/>
                    </InputGroup>
                  </Password>
                </Row>
                <Button
                  disabled={!confirm_request || requestPass === ''}
                  variant='primary'
                  type='submit'
                >
                  Request Information
                </Button>
              </form>
          </Container>
        </Panel>
        <Panel>
          <Header>
            <Headline hasDescription>Request GDPR Deletion</Headline>
          </Header>
          <Container>
            <WarningText>
              If you would like to request for your MissTravel account and associated data to be deleted, 
              please certify that you are an EU resident and then use the "Delete Account and Information" option below.
            </WarningText>
            <NoteText>
              Note: if you have submitted an information request above, you should wait to delete your account until that process is completed, 
              otherwise your information request may not successfully process.
            </NoteText>
              <Row>
                <Checkbox
                  value={deleteChecked}
                  id="deleteChecked"
                  label="I certify, under penalty of fraud, that I am a resident of an EU country."
                  onChange={this.onCheckboxChange}
                />
              </Row>
              <Row>
                <Password>
                  <InputGroup vertical inputLabel="Password">
                    <TextInput id="deletePass" type="password" value={deletePass} onChange={this.onPasswordChange}/>
                  </InputGroup>
                </Password>
              </Row>
              <Button
                disabled={!deleteChecked || deletePass === ''}
                variant='primary'
                onClick={this.toggleModal}
              >
                Delete Account and Information
              </Button>
          </Container>
          <GdprDeletionModal
            isOpen={modalOpen}
            handleClose={this.toggleModal}
            yesBtnMsg='Delete Anyway'
            noBtnMsg='Nevermind'
            pass={deletePass}
            profile={profile}
            requestGdprDeletion={requestGdprDeletion}
            hasError={hasError}
          />
        </Panel>
      </Container>
    )
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/pages/GDPR/LandingPage.jsx